import Vue from "vue";
import i18n from "@/fmt/i18n";

import * as accountingEnums from "./accountingEnums";
import * as agencyEnums from "./agencyEnums";
import * as airportEnums from "./airportEnums";
import * as authorizationEnums from "./authorizationEnums";
import * as bigJobEnums from "./bigJobEnums";
import * as cacheEnums from "./cacheEnums";
import * as cdnEnums from "./cdnEnums";
import * as commonEnums from "./commonEnums";
import * as cronEnums from "./cronEnums";
import * as dashboardEnums from "./dashboardEnums";
import * as documentEnums from "./documentEnums";
import * as emailEnums from "./emailEnums";
import * as entityEnums from "./entityEnums";
import * as eventEnums from "./eventEnums";
import * as exchangeEnums from "./exchangeEnums";
import * as fileStoreEnums from "./fileStoreEnums";
import * as financeEnums from "./financeEnums";
import * as flightEnums from "./flightEnums";
import * as ftpEnums from "./ftpEnums";
import * as gsaEnums from "./gsaEnums";
import * as hotelEnums from "./hotelEnums";
import * as invoiceEnums from "./invoiceEnums";
import * as jobHookEnums from "./jobHookEnums";
import * as locationEnums from "./locationEnums";
import * as noteEnums from "./noteEnums";
import * as notificationEnums from "./notificationEnums";
import * as orderEnums from "./orderEnums";
import * as paymentEnums from "./paymentEnums";
import * as processEnums from "./processEnums";
import * as providerEnums from "./providerEnums";
import * as rentACarEnums from "./rentACarEnums";
import * as reportEnums from "./reportEnums";
import * as schmetterlingEnums from "./schmetterlingEnums";
import * as supplierEnums from "./supplierEnums";
import * as taskEnums from "./taskEnums";
import * as testAutomationEnums from "./testAutomationEnums";
import * as transferEnums from "./transferEnums";
import * as userEnums from "./userEnums";

export default class GtsDropdownData extends Vue {
   Enums(enumObj, showAll = false, showUnknown = false, removedValuesList = [], prefix = "") {
      return Object.keys(enumObj)
         .filter((key) => {
            const numKey = Number(key);
            if (removedValuesList.includes(numKey)) return false;

            if (!showAll && key === "-1") return false;

            if (!showUnknown && key === "0") return false;
            return true;
         })
         .map((key) => {
            return {
               value: Number(key),
               name: i18n.t(`${prefix}${enumObj[key]}`) || i18n.t(`${prefix}UNKNOWN`),
            };
         })
         .sort((a, b) => a.value - b.value);
   }

   EAccAccountStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EAccAccountStatus_";
      return this.Enums(accountingEnums.EAccAccountStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EAccAccountType(showAll, showUnknown, removedValuesList) {
      const prefix = "EAccAccountType_";
      return this.Enums(accountingEnums.EAccAccountType, showAll, showUnknown, removedValuesList, prefix);
   }
   EAccAccountSubType(showAll, showUnknown, removedValuesList) {
      const prefix = "EAccAccountSubType_";
      return this.Enums(accountingEnums.EAccAccountSubType, showAll, showUnknown, removedValuesList, prefix);
   }
   EAccTransactionType(showAll, showUnknown, removedValuesList) {
      const prefix = "EAccTransactionType_";
      return this.Enums(accountingEnums.EAccTransactionType, showAll, showUnknown, removedValuesList, prefix);
   }
   EAccTrxGroupBy(showAll, showUnknown, removedValuesList) {
      const prefix = "EAccTrxGroupBy_";
      return this.Enums(accountingEnums.EAccTrxGroupBy, showAll, showUnknown, removedValuesList, prefix);
   }
   EAccDateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EAccDateType_";
      return this.Enums(accountingEnums.EAccDateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EAccReceiptType(showAll, showUnknown, removedValuesList) {
      const prefix = "EAccReceiptType_";
      return this.Enums(accountingEnums.EAccReceiptType, showAll, showUnknown, removedValuesList, prefix);
   }
   EAgencyContactTitle(showAll, showUnknown, removedValuesList) {
      const prefix = "EAgencyContactTitle_";
      return this.Enums(agencyEnums.EAgencyContactTitle, showAll, showUnknown, removedValuesList, prefix);
   }
   EAirportType(showAll, showUnknown, removedValuesList) {
      const prefix = "EAirportType_";
      return this.Enums(airportEnums.EAirportType, showAll, showUnknown, removedValuesList, prefix);
   }
   EAirportVerifyStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EAirportVerifyStatus_";
      return this.Enums(airportEnums.EAirportVerifyStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EAuthAuthType(showAll, showUnknown, removedValuesList) {
      const prefix = "EAuthAuthType_";
      return this.Enums(authorizationEnums.EAuthAuthType, showAll, showUnknown, removedValuesList, prefix);
   }
   EAuthActionType(showAll, showUnknown, removedValuesList) {
      const prefix = "EAuthActionType_";
      return this.Enums(authorizationEnums.EAuthActionType, showAll, showUnknown, removedValuesList, prefix);
   }
   EAuthModalMode(showAll, showUnknown, removedValuesList) {
      const prefix = "EAuthModalMode_";
      return this.Enums(authorizationEnums.EAuthModalMode, showAll, showUnknown, removedValuesList, prefix);
   }
   EAuthAgentRoles(showAll, showUnknown, removedValuesList) {
      const prefix = "EAuthAgentRoles_";
      return this.Enums(authorizationEnums.EAuthAgentRoles, showAll, showUnknown, removedValuesList, prefix);
   }
   EBigJobType(showAll, showUnknown, removedValuesList) {
      const prefix = "EBigJobType_";
      return this.Enums(bigJobEnums.EBigJobType, showAll, showUnknown, removedValuesList, prefix);
   }
   EBigJobStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EBigJobStatus_";
      return this.Enums(bigJobEnums.EBigJobStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EMemCacheType(showAll, showUnknown, removedValuesList) {
      const prefix = "EMemCacheType_";
      return this.Enums(cacheEnums.EMemCacheType, showAll, showUnknown, removedValuesList, prefix);
   }
   ECdnDocType(showAll, showUnknown, removedValuesList) {
      const prefix = "ECdnDocType_";
      return this.Enums(cdnEnums.ECdnDocType, showAll, showUnknown, removedValuesList, prefix);
   }
   ECdnDocGroupType(showAll, showUnknown, removedValuesList) {
      const prefix = "ECdnDocGroupType_";
      return this.Enums(cdnEnums.ECdnDocGroupType, showAll, showUnknown, removedValuesList, prefix);
   }
   ECdnFileType(showAll, showUnknown, removedValuesList) {
      const prefix = "ECdnFileType_";
      return this.Enums(cdnEnums.ECdnFileType, showAll, showUnknown, removedValuesList, prefix);
   }
   EComResult(showAll, showUnknown, removedValuesList) {
      const prefix = "EComResult_";
      return this.Enums(commonEnums.EComResult, showAll, showUnknown, removedValuesList, prefix);
   }
   EExtResultCode(showAll, showUnknown, removedValuesList) {
      const prefix = "EExtResultCode_";
      return this.Enums(commonEnums.EExtResultCode, showAll, showUnknown, removedValuesList, prefix);
   }
   EComState(showAll, showUnknown, removedValuesList) {
      const prefix = "EComState_";
      return this.Enums(commonEnums.EComState, showAll, showUnknown, removedValuesList, prefix);
   }
   EComStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EComStatus_";
      return this.Enums(commonEnums.EComStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EComAbility(showAll, showUnknown, removedValuesList) {
      const prefix = "EComAbility_";
      return this.Enums(commonEnums.EComAbility, showAll, showUnknown, removedValuesList, prefix);
   }
   EComGender(showAll, showUnknown, removedValuesList) {
      const prefix = "EComGender_";
      return this.Enums(commonEnums.EComGender, showAll, showUnknown, removedValuesList, prefix);
   }
   EComLanguage(showAll, showUnknown, removedValuesList) {
      const prefix = "EComLanguage_";
      return this.Enums(commonEnums.EComLanguage, showAll, showUnknown, removedValuesList, prefix);
   }
   EComCurrency(showAll, showUnknown, removedValuesList) {
      const prefix = "EComCurrency_";
      return this.Enums(commonEnums.EComCurrency, showAll, showUnknown, removedValuesList, prefix);
   }
   EComCountryType(showAll, showUnknown, removedValuesList) {
      const prefix = "EComCountryType_";
      return this.Enums(commonEnums.EComCountryType, showAll, showUnknown, removedValuesList, prefix);
   }
   EComApplication(showAll, showUnknown, removedValuesList) {
      const prefix = "EComApplication_";
      return this.Enums(commonEnums.EComApplication, showAll, showUnknown, removedValuesList, prefix);
   }
   EComUnit(showAll, showUnknown, removedValuesList) {
      const prefix = "EComUnit_";
      return this.Enums(commonEnums.EComUnit, showAll, showUnknown, removedValuesList, prefix);
   }
   EComLayer(showAll, showUnknown, removedValuesList) {
      const prefix = "EComLayer_";
      return this.Enums(commonEnums.EComLayer, showAll, showUnknown, removedValuesList, prefix);
   }
   EComLogLevel(showAll, showUnknown, removedValuesList) {
      const prefix = "EComLogLevel_";
      return this.Enums(commonEnums.EComLogLevel, showAll, showUnknown, removedValuesList, prefix);
   }
   EComObjectType(showAll, showUnknown, removedValuesList) {
      const prefix = "EComObjectType_";
      return this.Enums(commonEnums.EComObjectType, showAll, showUnknown, removedValuesList, prefix);
   }
   EComDay(showAll, showUnknown, removedValuesList) {
      const prefix = "EComDay_";
      return this.Enums(commonEnums.EComDay, showAll, showUnknown, removedValuesList, prefix);
   }
   ECronJobType(showAll, showUnknown, removedValuesList) {
      const prefix = "ECronJobType_";
      return this.Enums(cronEnums.ECronJobType, showAll, showUnknown, removedValuesList, prefix);
   }
   EDashWidgetType(showAll, showUnknown, removedValuesList) {
      const prefix = "EDashWidgetType_";
      return this.Enums(dashboardEnums.EDashWidgetType, showAll, showUnknown, removedValuesList, prefix);
   }
   EDashWidgetItem(showAll, showUnknown, removedValuesList) {
      const prefix = "EDashWidgetItem_";
      return this.Enums(dashboardEnums.EDashWidgetItem, showAll, showUnknown, removedValuesList, prefix);
   }
   EDashMainWidget(showAll, showUnknown, removedValuesList) {
      const prefix = "EDashMainWidget_";
      return this.Enums(dashboardEnums.EDashMainWidget, showAll, showUnknown, removedValuesList, prefix);
   }
   EDashSideWidget(showAll, showUnknown, removedValuesList) {
      const prefix = "EDashSideWidget_";
      return this.Enums(dashboardEnums.EDashSideWidget, showAll, showUnknown, removedValuesList, prefix);
   }
   EDocDocumentType(showAll, showUnknown, removedValuesList) {
      const prefix = "EDocDocumentType_";
      return this.Enums(documentEnums.EDocDocumentType, showAll, showUnknown, removedValuesList, prefix);
   }
   EDocFileType(showAll, showUnknown, removedValuesList) {
      const prefix = "EDocFileType_";
      return this.Enums(documentEnums.EDocFileType, showAll, showUnknown, removedValuesList, prefix);
   }
   EDocFontType(showAll, showUnknown, removedValuesList) {
      const prefix = "EDocFontType_";
      return this.Enums(documentEnums.EDocFontType, showAll, showUnknown, removedValuesList, prefix);
   }
   EEmailType(showAll, showUnknown, removedValuesList) {
      const prefix = "EEmailType_";
      return this.Enums(emailEnums.EEmailType, showAll, showUnknown, removedValuesList, prefix);
   }
   EEmailStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EEmailStatus_";
      return this.Enums(emailEnums.EEmailStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EEmailImportance(showAll, showUnknown, removedValuesList) {
      const prefix = "EEmailImportance_";
      return this.Enums(emailEnums.EEmailImportance, showAll, showUnknown, removedValuesList, prefix);
   }
   EEmailIOType(showAll, showUnknown, removedValuesList) {
      const prefix = "EEmailIOType_";
      return this.Enums(emailEnums.EEmailIOType, showAll, showUnknown, removedValuesList, prefix);
   }
   EEmailFromType(showAll, showUnknown, removedValuesList) {
      const prefix = "EEmailFromType_";
      return this.Enums(emailEnums.EEmailFromType, showAll, showUnknown, removedValuesList, prefix);
   }
   EEntityCheckStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EEntityCheckStatus_";
      return this.Enums(entityEnums.EEntityCheckStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EEntityCheckType(showAll, showUnknown, removedValuesList) {
      const prefix = "EEntityCheckType_";
      return this.Enums(entityEnums.EEntityCheckType, showAll, showUnknown, removedValuesList, prefix);
   }
   EEventType(showAll, showUnknown, removedValuesList) {
      const prefix = "EEventType_";
      return this.Enums(eventEnums.EEventType, showAll, showUnknown, removedValuesList, prefix);
   }
   EExchangeImplementationType(showAll, showUnknown, removedValuesList) {
      const prefix = "EExchangeImplementationType_";
      return this.Enums(exchangeEnums.EExchangeImplementationType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFsFileType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFsFileType_";
      return this.Enums(fileStoreEnums.EFsFileType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFsFileSubType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFsFileSubType_";
      return this.Enums(fileStoreEnums.EFsFileSubType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFsFileExtension(showAll, showUnknown, removedValuesList) {
      const prefix = "EFsFileExtension_";
      return this.Enums(fileStoreEnums.EFsFileExtension, showAll, showUnknown, removedValuesList, prefix);
   }
   EBalanceUpdateTrxType(showAll, showUnknown, removedValuesList) {
      const prefix = "EBalanceUpdateTrxType_";
      return this.Enums(financeEnums.EBalanceUpdateTrxType, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayCommissionType(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayCommissionType_";
      return this.Enums(financeEnums.EPayCommissionType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltPaxType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltPaxType_";
      return this.Enums(flightEnums.EFltPaxType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltPaxSubType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltPaxSubType_";
      return this.Enums(flightEnums.EFltPaxSubType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltCabinType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltCabinType_";
      return this.Enums(flightEnums.EFltCabinType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltTripType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltTripType_";
      return this.Enums(flightEnums.EFltTripType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltCountryType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltCountryType_";
      return this.Enums(flightEnums.EFltCountryType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltPnrStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltPnrStatus_";
      return this.Enums(flightEnums.EFltPnrStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltPnrImportType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltPnrImportType_";
      return this.Enums(flightEnums.EFltPnrImportType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltEticketStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltEticketStatus_";
      return this.Enums(flightEnums.EFltEticketStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltTicketUsageStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltTicketUsageStatus_";
      return this.Enums(flightEnums.EFltTicketUsageStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltAncillaryStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltAncillaryStatus_";
      return this.Enums(flightEnums.EFltAncillaryStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltFlightStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltFlightStatus_";
      return this.Enums(flightEnums.EFltFlightStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltSegmentStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltSegmentStatus_";
      return this.Enums(flightEnums.EFltSegmentStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltEticketTrxType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltEticketTrxType_";
      return this.Enums(flightEnums.EFltEticketTrxType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltPnrFlow(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltPnrFlow_";
      return this.Enums(flightEnums.EFltPnrFlow, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltPnrIssueType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltPnrIssueType_";
      return this.Enums(flightEnums.EFltPnrIssueType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltPnrReverseType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltPnrReverseType_";
      return this.Enums(flightEnums.EFltPnrReverseType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltPnrReverseEnabledType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltPnrReverseEnabledType_";
      return this.Enums(flightEnums.EFltPnrReverseEnabledType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltAirportType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltAirportType_";
      return this.Enums(flightEnums.EFltAirportType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltSearchType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltSearchType_";
      return this.Enums(flightEnums.EFltSearchType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltSearchRuleSearchType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltSearchRuleSearchType_";
      return this.Enums(flightEnums.EFltSearchRuleSearchType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltCommissionAmountType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltCommissionAmountType_";
      return this.Enums(flightEnums.EFltCommissionAmountType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltCommissionType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltCommissionType_";
      return this.Enums(flightEnums.EFltCommissionType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltReverseReason(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltReverseReason_";
      return this.Enums(flightEnums.EFltReverseReason, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltIrregularAirline(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltIrregularAirline_";
      return this.Enums(flightEnums.EFltIrregularAirline, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltSsrType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltSsrType_";
      return this.Enums(flightEnums.EFltSsrType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltSsrState(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltSsrState_";
      return this.Enums(flightEnums.EFltSsrState, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltBaggageUnit(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltBaggageUnit_";
      return this.Enums(flightEnums.EFltBaggageUnit, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltBaggageType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltBaggageType_";
      return this.Enums(flightEnums.EFltBaggageType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltPnrUserActionType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltPnrUserActionType_";
      return this.Enums(flightEnums.EFltPnrUserActionType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltSsrMealType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltSsrMealType_";
      return this.Enums(flightEnums.EFltSsrMealType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltSsrWheelchairType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltSsrWheelchairType_";
      return this.Enums(flightEnums.EFltSsrWheelchairType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltPnrCcCheckStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltPnrCcCheckStatus_";
      return this.Enums(flightEnums.EFltPnrCcCheckStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltReportDateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltReportDateType_";
      return this.Enums(flightEnums.EFltReportDateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltWarnType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltWarnType_";
      return this.Enums(flightEnums.EFltWarnType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltReissueAvailType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltReissueAvailType_";
      return this.Enums(flightEnums.EFltReissueAvailType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltFlightTimeTableStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltFlightTimeTableStatus_";
      return this.Enums(flightEnums.EFltFlightTimeTableStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltSeatStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltSeatStatus_";
      return this.Enums(flightEnums.EFltSeatStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltSeatType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltSeatType_";
      return this.Enums(flightEnums.EFltSeatType, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltSeatLayout(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltSeatLayout_";
      return this.Enums(flightEnums.EFltSeatLayout, showAll, showUnknown, removedValuesList, prefix);
   }
   EFltEticketNoShowStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EFltEticketNoShowStatus_";
      return this.Enums(flightEnums.EFltEticketNoShowStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EFtpDocType(showAll, showUnknown, removedValuesList) {
      const prefix = "EFtpDocType_";
      return this.Enums(ftpEnums.EFtpDocType, showAll, showUnknown, removedValuesList, prefix);
   }
   EGsaType(showAll, showUnknown, removedValuesList) {
      const prefix = "EGsaType_";
      return this.Enums(gsaEnums.EGsaType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHotelStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EHotelStatus_";
      return this.Enums(hotelEnums.EHotelStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlMapingType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlMapingType_";
      return this.Enums(hotelEnums.EHtlMapingType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlMapingStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlMapingStatus_";
      return this.Enums(hotelEnums.EHtlMapingStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EHotelRegion(showAll, showUnknown, removedValuesList) {
      const prefix = "EHotelRegion_";
      return this.Enums(hotelEnums.EHotelRegion, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlGuestType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlGuestType_";
      return this.Enums(hotelEnums.EHtlGuestType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlVoucherStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlVoucherStatus_";
      return this.Enums(hotelEnums.EHtlVoucherStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlRoomPriceStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlRoomPriceStatus_";
      return this.Enums(hotelEnums.EHtlRoomPriceStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlAddOnStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlAddOnStatus_";
      return this.Enums(hotelEnums.EHtlAddOnStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlImportType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlImportType_";
      return this.Enums(hotelEnums.EHtlImportType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlAmountType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlAmountType_";
      return this.Enums(hotelEnums.EHtlAmountType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlPolicyType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlPolicyType_";
      return this.Enums(hotelEnums.EHtlPolicyType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlCommissionType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlCommissionType_";
      return this.Enums(hotelEnums.EHtlCommissionType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlCommissionRatioType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlCommissionRatioType_";
      return this.Enums(hotelEnums.EHtlCommissionRatioType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlSearchType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlSearchType_";
      return this.Enums(hotelEnums.EHtlSearchType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlContentUpdateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlContentUpdateType_";
      return this.Enums(hotelEnums.EHtlContentUpdateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlContentItemStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlContentItemStatus_";
      return this.Enums(hotelEnums.EHtlContentItemStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlHotelVerifyStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlHotelVerifyStatus_";
      return this.Enums(hotelEnums.EHtlHotelVerifyStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlOptionNotifyStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlOptionNotifyStatus_";
      return this.Enums(hotelEnums.EHtlOptionNotifyStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlImageCategory(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlImageCategory_";
      return this.Enums(hotelEnums.EHtlImageCategory, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlVoucherReverseEnabledType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlVoucherReverseEnabledType_";
      return this.Enums(hotelEnums.EHtlVoucherReverseEnabledType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlAmountForceType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlAmountForceType_";
      return this.Enums(hotelEnums.EHtlAmountForceType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlRefundType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlRefundType_";
      return this.Enums(hotelEnums.EHtlRefundType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlPriceViewType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlPriceViewType_";
      return this.Enums(hotelEnums.EHtlPriceViewType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlPaymentType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlPaymentType_";
      return this.Enums(hotelEnums.EHtlPaymentType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlPaymentStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlPaymentStatus_";
      return this.Enums(hotelEnums.EHtlPaymentStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EHotelContactTitle(showAll, showUnknown, removedValuesList) {
      const prefix = "EHotelContactTitle_";
      return this.Enums(hotelEnums.EHotelContactTitle, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlFacilityType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlFacilityType_";
      return this.Enums(hotelEnums.EHtlFacilityType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlBedType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlBedType_";
      return this.Enums(hotelEnums.EHtlBedType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlRoomGroup(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlRoomGroup_";
      return this.Enums(hotelEnums.EHtlRoomGroup, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlStopType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlStopType_";
      return this.Enums(hotelEnums.EHtlStopType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlPenaltyType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlPenaltyType_";
      return this.Enums(hotelEnums.EHtlPenaltyType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlPriceRestrictionType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlPriceRestrictionType_";
      return this.Enums(hotelEnums.EHtlPriceRestrictionType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlNoteType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlNoteType_";
      return this.Enums(hotelEnums.EHtlNoteType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlNoteSubType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlNoteSubType_";
      return this.Enums(hotelEnums.EHtlNoteSubType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlPageType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlPageType_";
      return this.Enums(hotelEnums.EHtlPageType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlSpoType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlSpoType_";
      return this.Enums(hotelEnums.EHtlSpoType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlSpoFreeDayType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlSpoFreeDayType_";
      return this.Enums(hotelEnums.EHtlSpoFreeDayType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlContentImportType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlContentImportType_";
      return this.Enums(hotelEnums.EHtlContentImportType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlKickbackType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlKickbackType_";
      return this.Enums(hotelEnums.EHtlKickbackType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlContractType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlContractType_";
      return this.Enums(hotelEnums.EHtlContractType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlHotelStarCategory(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlHotelStarCategory_";
      return this.Enums(hotelEnums.EHtlHotelStarCategory, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlSpoCumulateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlSpoCumulateType_";
      return this.Enums(hotelEnums.EHtlSpoCumulateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlSearchCacheSyncType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlSearchCacheSyncType_";
      return this.Enums(hotelEnums.EHtlSearchCacheSyncType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlSearchCacheSyncStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlSearchCacheSyncStatus_";
      return this.Enums(hotelEnums.EHtlSearchCacheSyncStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlChildType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlChildType_";
      return this.Enums(hotelEnums.EHtlChildType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlContractSettingsType(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlContractSettingsType_";
      return this.Enums(hotelEnums.EHtlContractSettingsType, showAll, showUnknown, removedValuesList, prefix);
   }
   EHtlPriceBlockStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EHtlPriceBlockStatus_";
      return this.Enums(hotelEnums.EHtlPriceBlockStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EInvoiceStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EInvoiceStatus_";
      return this.Enums(invoiceEnums.EInvoiceStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EInvoiceType(showAll, showUnknown, removedValuesList) {
      const prefix = "EInvoiceType_";
      return this.Enums(invoiceEnums.EInvoiceType, showAll, showUnknown, removedValuesList, prefix);
   }
   EInvoiceHeaderType(showAll, showUnknown, removedValuesList) {
      const prefix = "EInvoiceHeaderType_";
      return this.Enums(invoiceEnums.EInvoiceHeaderType, showAll, showUnknown, removedValuesList, prefix);
   }
   EInvoiceIO(showAll, showUnknown, removedValuesList) {
      const prefix = "EInvoiceIO_";
      return this.Enums(invoiceEnums.EInvoiceIO, showAll, showUnknown, removedValuesList, prefix);
   }
   EInvoiceTrxViewType(showAll, showUnknown, removedValuesList) {
      const prefix = "EInvoiceTrxViewType_";
      return this.Enums(invoiceEnums.EInvoiceTrxViewType, showAll, showUnknown, removedValuesList, prefix);
   }
   EInvoicePackageType(showAll, showUnknown, removedValuesList) {
      const prefix = "EInvoicePackageType_";
      return this.Enums(invoiceEnums.EInvoicePackageType, showAll, showUnknown, removedValuesList, prefix);
   }
   EInvoiceDateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EInvoiceDateType_";
      return this.Enums(invoiceEnums.EInvoiceDateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EInvoicePeriodType(showAll, showUnknown, removedValuesList) {
      const prefix = "EInvoicePeriodType_";
      return this.Enums(invoiceEnums.EInvoicePeriodType, showAll, showUnknown, removedValuesList, prefix);
   }
   EJobHookIntegrationType(showAll, showUnknown, removedValuesList) {
      const prefix = "EJobHookIntegrationType_";
      return this.Enums(jobHookEnums.EJobHookIntegrationType, showAll, showUnknown, removedValuesList, prefix);
   }
   EJobHookJobType(showAll, showUnknown, removedValuesList) {
      const prefix = "EJobHookJobType_";
      return this.Enums(jobHookEnums.EJobHookJobType, showAll, showUnknown, removedValuesList, prefix);
   }
   EJobHookJobStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EJobHookJobStatus_";
      return this.Enums(jobHookEnums.EJobHookJobStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ELocationCategory(showAll, showUnknown, removedValuesList) {
      const prefix = "ELocationCategory_";
      return this.Enums(locationEnums.ELocationCategory, showAll, showUnknown, removedValuesList, prefix);
   }
   ELocationStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ELocationStatus_";
      return this.Enums(locationEnums.ELocationStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ELocationType(showAll, showUnknown, removedValuesList) {
      const prefix = "ELocationType_";
      return this.Enums(locationEnums.ELocationType, showAll, showUnknown, removedValuesList, prefix);
   }
   EDestinationType(showAll, showUnknown, removedValuesList) {
      const prefix = "EDestinationType_";
      return this.Enums(locationEnums.EDestinationType, showAll, showUnknown, removedValuesList, prefix);
   }
   EDestinationSyncStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EDestinationSyncStatus_";
      return this.Enums(locationEnums.EDestinationSyncStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ECountryPatternType(showAll, showUnknown, removedValuesList) {
      const prefix = "ECountryPatternType_";
      return this.Enums(locationEnums.ECountryPatternType, showAll, showUnknown, removedValuesList, prefix);
   }
   ENoteVisibility(showAll, showUnknown, removedValuesList) {
      const prefix = "ENoteVisibility_";
      return this.Enums(noteEnums.ENoteVisibility, showAll, showUnknown, removedValuesList, prefix);
   }
   EScriptPlaceholder(showAll, showUnknown, removedValuesList) {
      const prefix = "EScriptPlaceholder_";
      return this.Enums(noteEnums.EScriptPlaceholder, showAll, showUnknown, removedValuesList, prefix);
   }
   EContactType(showAll, showUnknown, removedValuesList) {
      const prefix = "EContactType_";
      return this.Enums(noteEnums.EContactType, showAll, showUnknown, removedValuesList, prefix);
   }
   ENotificationType(showAll, showUnknown, removedValuesList) {
      const prefix = "ENotificationType_";
      return this.Enums(notificationEnums.ENotificationType, showAll, showUnknown, removedValuesList, prefix);
   }
   ENotificationStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ENotificationStatus_";
      return this.Enums(notificationEnums.ENotificationStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EAnnouncementCategory(showAll, showUnknown, removedValuesList) {
      const prefix = "EAnnouncementCategory_";
      return this.Enums(notificationEnums.EAnnouncementCategory, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrSearchStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrSearchStatus_";
      return this.Enums(orderEnums.EOdrSearchStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrOrderStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrOrderStatus_";
      return this.Enums(orderEnums.EOdrOrderStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrType(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrType_";
      return this.Enums(orderEnums.EOdrType, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrEntityType(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrEntityType_";
      return this.Enums(orderEnums.EOdrEntityType, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrSubEntityType(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrSubEntityType_";
      return this.Enums(orderEnums.EOdrSubEntityType, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrImportType(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrImportType_";
      return this.Enums(orderEnums.EOdrImportType, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrErrorType(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrErrorType_";
      return this.Enums(orderEnums.EOdrErrorType, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrTrxType(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrTrxType_";
      return this.Enums(orderEnums.EOdrTrxType, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrSearchHotelDateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrSearchHotelDateType_";
      return this.Enums(orderEnums.EOdrSearchHotelDateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrSearchTransferDateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrSearchTransferDateType_";
      return this.Enums(orderEnums.EOdrSearchTransferDateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrSearchRentACarDateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrSearchRentACarDateType_";
      return this.Enums(orderEnums.EOdrSearchRentACarDateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EOdrConfirmationSource(showAll, showUnknown, removedValuesList) {
      const prefix = "EOdrConfirmationSource_";
      return this.Enums(orderEnums.EOdrConfirmationSource, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayPaymentStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayPaymentStatus_";
      return this.Enums(paymentEnums.EPayPaymentStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayVcardStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayVcardStatus_";
      return this.Enums(paymentEnums.EPayVcardStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayVcardTrxStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayVcardTrxStatus_";
      return this.Enums(paymentEnums.EPayVcardTrxStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayVcardTrxType(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayVcardTrxType_";
      return this.Enums(paymentEnums.EPayVcardTrxType, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayPaymentType(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayPaymentType_";
      return this.Enums(paymentEnums.EPayPaymentType, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayTransactionType(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayTransactionType_";
      return this.Enums(paymentEnums.EPayTransactionType, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayVposImplementationType(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayVposImplementationType_";
      return this.Enums(paymentEnums.EPayVposImplementationType, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayCardType(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayCardType_";
      return this.Enums(paymentEnums.EPayCardType, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayCardBrand(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayCardBrand_";
      return this.Enums(paymentEnums.EPayCardBrand, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayCardOwner(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayCardOwner_";
      return this.Enums(paymentEnums.EPayCardOwner, showAll, showUnknown, removedValuesList, prefix);
   }
   EPayPaymentFinalizeType(showAll, showUnknown, removedValuesList) {
      const prefix = "EPayPaymentFinalizeType_";
      return this.Enums(paymentEnums.EPayPaymentFinalizeType, showAll, showUnknown, removedValuesList, prefix);
   }
   EProcessType(showAll, showUnknown, removedValuesList) {
      const prefix = "EProcessType_";
      return this.Enums(processEnums.EProcessType, showAll, showUnknown, removedValuesList, prefix);
   }
   EProcessStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EProcessStatus_";
      return this.Enums(processEnums.EProcessStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EProgressType(showAll, showUnknown, removedValuesList) {
      const prefix = "EProgressType_";
      return this.Enums(processEnums.EProgressType, showAll, showUnknown, removedValuesList, prefix);
   }
   EProgressStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EProgressStatus_";
      return this.Enums(processEnums.EProgressStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EProProductType(showAll, showUnknown, removedValuesList) {
      const prefix = "EProProductType_";
      return this.Enums(providerEnums.EProProductType, showAll, showUnknown, removedValuesList, prefix);
   }
   EProProviderType(showAll, showUnknown, removedValuesList) {
      const prefix = "EProProviderType_";
      return this.Enums(providerEnums.EProProviderType, showAll, showUnknown, removedValuesList, prefix);
   }
   EProChannelType(showAll, showUnknown, removedValuesList) {
      const prefix = "EProChannelType_";
      return this.Enums(providerEnums.EProChannelType, showAll, showUnknown, removedValuesList, prefix);
   }
   EProSalesChannelType(showAll, showUnknown, removedValuesList) {
      const prefix = "EProSalesChannelType_";
      return this.Enums(providerEnums.EProSalesChannelType, showAll, showUnknown, removedValuesList, prefix);
   }
   EProImplementationType(showAll, showUnknown, removedValuesList) {
      const prefix = "EProImplementationType_";
      return this.Enums(providerEnums.EProImplementationType, showAll, showUnknown, removedValuesList, prefix);
   }
   EProEodType(showAll, showUnknown, removedValuesList) {
      const prefix = "EProEodType_";
      return this.Enums(providerEnums.EProEodType, showAll, showUnknown, removedValuesList, prefix);
   }
   EProLoginStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EProLoginStatus_";
      return this.Enums(providerEnums.EProLoginStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacBodyType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacBodyType_";
      return this.Enums(rentACarEnums.ERacBodyType, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacProductType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacProductType_";
      return this.Enums(rentACarEnums.ERacProductType, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacAncillaryType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacAncillaryType_";
      return this.Enums(rentACarEnums.ERacAncillaryType, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacFacilityType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacFacilityType_";
      return this.Enums(rentACarEnums.ERacFacilityType, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacRnrStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacRnrStatus_";
      return this.Enums(rentACarEnums.ERacRnrStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacVehicleStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacVehicleStatus_";
      return this.Enums(rentACarEnums.ERacVehicleStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacVehiclePriceStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacVehiclePriceStatus_";
      return this.Enums(rentACarEnums.ERacVehiclePriceStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacAncillaryStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacAncillaryStatus_";
      return this.Enums(rentACarEnums.ERacAncillaryStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacGearType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacGearType_";
      return this.Enums(rentACarEnums.ERacGearType, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacFuelType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacFuelType_";
      return this.Enums(rentACarEnums.ERacFuelType, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacImportType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacImportType_";
      return this.Enums(rentACarEnums.ERacImportType, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacCommissionRatioType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacCommissionRatioType_";
      return this.Enums(rentACarEnums.ERacCommissionRatioType, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacCommissionType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacCommissionType_";
      return this.Enums(rentACarEnums.ERacCommissionType, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacCommissionAmountType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacCommissionAmountType_";
      return this.Enums(rentACarEnums.ERacCommissionAmountType, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacProviderDocType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacProviderDocType_";
      return this.Enums(rentACarEnums.ERacProviderDocType, showAll, showUnknown, removedValuesList, prefix);
   }
   ERacRnrReverseEnabledType(showAll, showUnknown, removedValuesList) {
      const prefix = "ERacRnrReverseEnabledType_";
      return this.Enums(rentACarEnums.ERacRnrReverseEnabledType, showAll, showUnknown, removedValuesList, prefix);
   }
   EReportFlightDateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EReportFlightDateType_";
      return this.Enums(reportEnums.EReportFlightDateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EReportHotelDateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EReportHotelDateType_";
      return this.Enums(reportEnums.EReportHotelDateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EReportTransferDateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EReportTransferDateType_";
      return this.Enums(reportEnums.EReportTransferDateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EReportRentACarDateType(showAll, showUnknown, removedValuesList) {
      const prefix = "EReportRentACarDateType_";
      return this.Enums(reportEnums.EReportRentACarDateType, showAll, showUnknown, removedValuesList, prefix);
   }
   EReportRentACarReportType(showAll, showUnknown, removedValuesList) {
      const prefix = "EReportRentACarReportType_";
      return this.Enums(reportEnums.EReportRentACarReportType, showAll, showUnknown, removedValuesList, prefix);
   }
   EReportSalesSumReportType(showAll, showUnknown, removedValuesList) {
      const prefix = "EReportSalesSumReportType_";
      return this.Enums(reportEnums.EReportSalesSumReportType, showAll, showUnknown, removedValuesList, prefix);
   }
   EReportSalesType(showAll, showUnknown, removedValuesList) {
      const prefix = "EReportSalesType_";
      return this.Enums(reportEnums.EReportSalesType, showAll, showUnknown, removedValuesList, prefix);
   }
   EReportHotelSearchType(showAll, showUnknown, removedValuesList) {
      const prefix = "EReportHotelSearchType_";
      return this.Enums(reportEnums.EReportHotelSearchType, showAll, showUnknown, removedValuesList, prefix);
   }
   EReportCmnGsaInvoiceProductType(showAll, showUnknown, removedValuesList) {
      const prefix = "EReportCmnGsaInvoiceProductType_";
      return this.Enums(reportEnums.EReportCmnGsaInvoiceProductType, showAll, showUnknown, removedValuesList, prefix);
   }
   ESchmetterlingOrderStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ESchmetterlingOrderStatus_";
      return this.Enums(schmetterlingEnums.ESchmetterlingOrderStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ESupSupplierType(showAll, showUnknown, removedValuesList) {
      const prefix = "ESupSupplierType_";
      return this.Enums(supplierEnums.ESupSupplierType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskType_";
      return this.Enums(taskEnums.ETaskType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskSubType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskSubType_";
      return this.Enums(taskEnums.ETaskSubType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskStatus_";
      return this.Enums(taskEnums.ETaskStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskSubStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskSubStatus_";
      return this.Enums(taskEnums.ETaskSubStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskClosingType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskClosingType_";
      return this.Enums(taskEnums.ETaskClosingType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskSource(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskSource_";
      return this.Enums(taskEnums.ETaskSource, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskMedia(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskMedia_";
      return this.Enums(taskEnums.ETaskMedia, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskVisibility(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskVisibility_";
      return this.Enums(taskEnums.ETaskVisibility, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskPnrReverseReason(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskPnrReverseReason_";
      return this.Enums(taskEnums.ETaskPnrReverseReason, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskVoucherReverseReason(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskVoucherReverseReason_";
      return this.Enums(taskEnums.ETaskVoucherReverseReason, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskTnrReverseReason(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskTnrReverseReason_";
      return this.Enums(taskEnums.ETaskTnrReverseReason, showAll, showUnknown, removedValuesList, prefix);
   }
   ETaskRnrReverseReason(showAll, showUnknown, removedValuesList) {
      const prefix = "ETaskRnrReverseReason_";
      return this.Enums(taskEnums.ETaskRnrReverseReason, showAll, showUnknown, removedValuesList, prefix);
   }
   ETasScenarioType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETasScenarioType_";
      return this.Enums(testAutomationEnums.ETasScenarioType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETasLogStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ETasLogStatus_";
      return this.Enums(testAutomationEnums.ETasLogStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfVehicleCategory(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfVehicleCategory_";
      return this.Enums(transferEnums.ETrfVehicleCategory, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfSaleStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfSaleStatus_";
      return this.Enums(transferEnums.ETrfSaleStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfAncillaryType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfAncillaryType_";
      return this.Enums(transferEnums.ETrfAncillaryType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfTnrStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfTnrStatus_";
      return this.Enums(transferEnums.ETrfTnrStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfLegStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfLegStatus_";
      return this.Enums(transferEnums.ETrfLegStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfAncillaryStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfAncillaryStatus_";
      return this.Enums(transferEnums.ETrfAncillaryStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfOperationStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfOperationStatus_";
      return this.Enums(transferEnums.ETrfOperationStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfImportType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfImportType_";
      return this.Enums(transferEnums.ETrfImportType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfTripType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfTripType_";
      return this.Enums(transferEnums.ETrfTripType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfRouteType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfRouteType_";
      return this.Enums(transferEnums.ETrfRouteType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfCommissionRatioType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfCommissionRatioType_";
      return this.Enums(transferEnums.ETrfCommissionRatioType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfCommisionType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfCommisionType_";
      return this.Enums(transferEnums.ETrfCommisionType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfCommisionAmountType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfCommisionAmountType_";
      return this.Enums(transferEnums.ETrfCommisionAmountType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfTransferType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfTransferType_";
      return this.Enums(transferEnums.ETrfTransferType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfProductType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfProductType_";
      return this.Enums(transferEnums.ETrfProductType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfTravelerType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfTravelerType_";
      return this.Enums(transferEnums.ETrfTravelerType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfRouteOriginType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfRouteOriginType_";
      return this.Enums(transferEnums.ETrfRouteOriginType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfMappingType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfMappingType_";
      return this.Enums(transferEnums.ETrfMappingType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfMappingStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfMappingStatus_";
      return this.Enums(transferEnums.ETrfMappingStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfFacilityType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfFacilityType_";
      return this.Enums(transferEnums.ETrfFacilityType, showAll, showUnknown, removedValuesList, prefix);
   }
   ETrfTnrReverseEnabledType(showAll, showUnknown, removedValuesList) {
      const prefix = "ETrfTnrReverseEnabledType_";
      return this.Enums(transferEnums.ETrfTnrReverseEnabledType, showAll, showUnknown, removedValuesList, prefix);
   }
   EUserType(showAll, showUnknown, removedValuesList) {
      const prefix = "EUserType_";
      return this.Enums(userEnums.EUserType, showAll, showUnknown, removedValuesList, prefix);
   }
   EUsrOperatorTaskAvailabilty(showAll, showUnknown, removedValuesList) {
      const prefix = "EUsrOperatorTaskAvailabilty_";
      return this.Enums(userEnums.EUsrOperatorTaskAvailabilty, showAll, showUnknown, removedValuesList, prefix);
   }
   EUsrOperatorCallAvailabilty(showAll, showUnknown, removedValuesList) {
      const prefix = "EUsrOperatorCallAvailabilty_";
      return this.Enums(userEnums.EUsrOperatorCallAvailabilty, showAll, showUnknown, removedValuesList, prefix);
   }
   EUserTotp(showAll, showUnknown, removedValuesList) {
      const prefix = "EUserTotp_";
      return this.Enums(userEnums.EUserTotp, showAll, showUnknown, removedValuesList, prefix);
   }
   EUserLoginStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EUserLoginStatus_";
      return this.Enums(userEnums.EUserLoginStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   EUserOnBeHalfOfStatus(showAll, showUnknown, removedValuesList) {
      const prefix = "EUserOnBeHalfOfStatus_";
      return this.Enums(userEnums.EUserOnBeHalfOfStatus, showAll, showUnknown, removedValuesList, prefix);
   }
   dateMonthArray() {
      return [
         { name: i18n.t("common_january"), value: 0 },
         { name: i18n.t("common_february"), value: 1 },
         { name: i18n.t("common_march"), value: 2 },
         { name: i18n.t("common_april"), value: 3 },
         { name: i18n.t("common_may"), value: 4 },
         { name: i18n.t("common_june"), value: 5 },
         { name: i18n.t("common_july"), value: 6 },
         { name: i18n.t("common_august"), value: 7 },
         { name: i18n.t("common_september"), value: 8 },
         { name: i18n.t("common_october"), value: 9 },
         { name: i18n.t("common_november"), value: 10 },
         { name: i18n.t("common_december"), value: 11 },
      ];
   }
}
